import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdministradoraInserirComponent } from './administradora-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: AdministradoraInserirComponent }
    ])],
    exports: [RouterModule]
})
export class AdministradoraInserirRoutingModule { }
